import apiClient from './apiClient';

export const laoService = {
  getConfig: () => apiClient.get('/lao/config').then((res) => res.data),
  getOverview: () => apiClient.get('/lao/overview').then((res) => res.data),
  getHistory: (limit) =>
    apiClient
      .get('/lao/history', { params: limit ? { limit } : undefined })
      .then((res) => res.data),
  getBets: (params) =>
    apiClient.get('/lao/bets', { params }).then((res) => res.data),
  placeBets: (payload) =>
    apiClient.post('/lao/bets', payload).then((res) => res.data),
};
